// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tFnERf_Vg9lGkO3Xr4hR {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  border: solid 2px var(--white-ish);\n}\n", "",{"version":3,"sources":["webpack://./src/components/editor/controls/KeyController/KeyController.css"],"names":[],"mappings":"AAAA;EACE,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,kCAAkC;AACpC","sourcesContent":[".keyController {\n  width: max-content;\n  border: solid 2px var(--white-ish);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyController": "tFnERf_Vg9lGkO3Xr4hR"
};
export default ___CSS_LOADER_EXPORT___;
